import { render, staticRenderFns } from "./ModalNew.vue?vue&type=template&id=01eac854&scoped=true&"
import script from "./ModalNew.vue?vue&type=script&lang=js&"
export * from "./ModalNew.vue?vue&type=script&lang=js&"
import style0 from "./ModalNew.vue?vue&type=style&index=0&id=01eac854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eac854",
  null
  
)

export default component.exports